import React from "react";
import { Link, useLocation } from "react-router-dom";
import i18n from "../../i18n";

const Breadcrumbs: React.FC = () => {
  const location = useLocation();
  const path = location.pathname.replace(/^\/[^/]+\/docs\/?/, "");
  const parts = path ? path.split("/") : [];
  const lang = i18n.language.split("-")[0];

  return (
    <nav
      className="text-sm text-gray-600 dark:text-gray-300 mb-3"
      aria-label="Breadcrumb"
    >
      <ol className="flex flex-wrap items-center gap-1">
        <li>
          <Link className="hover:underline" to={`/${lang}/docs`}>
            Docs
          </Link>
        </li>
        {parts.map((seg, i) => {
          const href = `/${lang}/docs/` + parts.slice(0, i + 1).join("/");
          const isLast = i === parts.length - 1;
          return (
            <li key={href} className="flex items-center gap-1">
              <span>/</span>
              {isLast ? (
                <span className="font-medium">{seg.replace(/-/g, " ")}</span>
              ) : (
                <Link className="hover:underline" to={href}>
                  {seg.replace(/-/g, " ")}
                </Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
